import { render, staticRenderFns } from "./AdminShippers.vue?vue&type=template&id=79bf6868"
import script from "./AdminShippers.vue?vue&type=script&lang=js"
export * from "./AdminShippers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gl-apistage/apistage.greenlists.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79bf6868')) {
      api.createRecord('79bf6868', component.options)
    } else {
      api.reload('79bf6868', component.options)
    }
    module.hot.accept("./AdminShippers.vue?vue&type=template&id=79bf6868", function () {
      api.rerender('79bf6868', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/pages/AdminShippers.vue"
export default component.exports